import React, { useState } from 'react';
import BrandImage from './BrandImage';

const brands = [
  { name: 'LA SERENISIMA', logo: '/brands-clients/logo_2020.png' },
  { name: 'AVON', logo: '/brands-clients/images.png' },
  { name: 'FERRUM', logo: '/brands-clients/Ferrum.png' },
  { name: 'ALUAR', logo: '/brands-clients/logo-vector-aluar.webp' },
  { name: 'GONVARRI', logo: '/brands-clients/gonvarri-logo.svg' },
  { name: 'ACERBRAG', logo: '/brands-clients/logo-acerbrag.svg' },
  { name: 'REGINALD LEE', logo: '/brands-clients/LOGO-REGINALD-LEE-SIN-FONDO.webp' },
  { name: 'SINTARYC', logo: '/brands-clients/Logo-wp.png' },
  { name: 'CERAMICA ALBERDI', logo: '/brands-clients/logo.png' },
  { name: 'GULF OIL ARGENTINA', logo: '/brands-clients/gulf-logo-250.png' },
  { name: 'CELULOSA CAMPANA', logo: '/brands-clients/CelulosaCampanaLogo.webp' },
  { name: 'EVONIK METILATOS SA', logo: '/brands-clients/evonik2020.svg' },
  { name: 'ACOPLADOS SALTO', logo: '/brands-clients/Salto_logo.png' },
  { name: 'AMIA', logo: '/brands-clients/Amia_logo_3.png' },
  { name: 'CORVEN', logo: '/brands-clients/Logo_corven.png' },
  { name: 'MAXICONSUMO', logo: '/brands-clients/newlogo-header.png' },
  { name: 'INDUSTRIAS LEAR', logo: '/brands-clients/Lear-logo.svg' },
  { name: 'KROMBERG & SCHUBERT', logo: '/brands-clients/Logo_Kroschu_Group.jpg' },
  { name: 'ACINDAR', logo: '/brands-clients/Acindar.webp' },
  { name: 'CARGILL', logo: '/brands-clients/Cargill.webp' },
  { name: 'JOHN DEERE', logo: '/brands-clients/JohnDeere.webp' },
  { name: 'TERNIUM', logo: '/brands-clients/Ternium.webp' },
];

const BrandShowcase = () => {
  const [failedClients, setFailedClients] = useState<Set<string>>(new Set());

  const handleClientImageError = (clientName: string) => {
    console.warn(`[ClientCarousel] Cliente "${clientName}" no pudo cargar su imagen. Mostrando fallback de texto.`);
    setFailedClients(prev => new Set(prev).add(clientName));
  };

  return (
    <section className="w-full bg-white py-12 md:pt-28 md:pb-28">
      <div className="container mx-auto px-4 md:px-26">
        {/* Mobile: Grid compacto de 3 columnas */}
        <div className="grid grid-cols-3 sm:hidden gap-3 items-center">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="flex justify-center items-center h-14 transition-transform duration-200 hover:-translate-y-1"
              title={brand.name}
            >
              <BrandImage
                src={brand.logo}
                alt={brand.name}
                className="max-h-8 w-full object-contain grayscale hover:grayscale-0 transition duration-300"
                fallbackType="text"
                onError={handleClientImageError}
              />
            </div>
          ))}
        </div>

        {/* Desktop y Tablet: Grid original */}
        <div className="hidden sm:grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-10 items-center">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="flex justify-center items-center h-20 transition-transform duration-200 hover:-translate-y-1"
              title={brand.name}
            >
              <BrandImage
                src={brand.logo}
                alt={brand.name}
                className="max-h-12 w-full object-contain grayscale hover:grayscale-0 transition duration-300"
                fallbackType="text"
                onError={handleClientImageError}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandShowcase;
